import React, { Fragment } from 'react';
import { twMerge } from 'tailwind-merge';

const ImageMedia = ({ ref, bypass=true, src, title, tag, className, loading, dim, hover, ...props }) => {

  const MediaParent = bypass ? Fragment : "div";

  const Component = () => {
    return ( <img src={src} ref={ref} id={title}
        loading={loading || "eager"}
        sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
        className={twMerge('select-none object-cover pointer-events-none', dim && "brightness-[.4] ", hover && "group-hover:brightness-[1] brightness-100", className)}
        alt={title}
        {...props}
      />
    )
  }
  return (
    <MediaParent>
      {bypass ?
        <Component />
        :
        <div className={twMerge("flex full relative overflow-clip center", className)}>
          <Component />
        </div>
      }
    </MediaParent>
  );
}

export default ImageMedia;
